/*
 * Copyright (c) 2023 Trimble Inc. All rights reserved.
 */

import { CircularProgress, List, ListItem, ListItemText, Paper } from '@mui/material';
import Grid from '@mui/material/Grid';
import { withStyles } from '@mui/styles';
const GridAny: any = Grid;
const ListItemAny: any = ListItem;
import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { isRoleExists } from '../common/common';
import { actionCreators } from '../store/ViewGeneralServiceInformation';
import EditGSInfo from './EditGSInfo';
import GSInfoSearch from './GSInfoSearch';
import MenuList from './MenuList';
import UploadBulletin from './UploadBulletinView';
import UploadGSInfoView from './UploadGSInfoView';


const styles = () => ({
    selectInput: {
        backgroundColor: '#fff',
        borderRadius: 0,
        boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.2)',
        '& em': {
            fontSize: 14,
            fontStyle: 'normal'
        }
    },
    dropdown: {
        fontSize: 14,
        fontStyle: 'normal',
        marginLeft: 10
    },
    bulletinleftPanelistItem: {
        overflow: 'hidden',
        whiteSpace: 'noWrap',
        textOverflow: 'ellipsis',
        width: '90%',
        fontSize: 10,

    },
    GsInfoMargin: {
        marginRight: 10
    },
    gsbulletinleftPanelistItem: {
        overflow: 'hidden',
        whiteSpace: 'noWrap',
        textOverflow: 'ellipsis',
        width: '90%',
        fontSize: 10,
        color: 'grey'
    },
    ListItemactive:
    {
        '&:hover': {
            backgroundColor: 'lightblue',
        },
        '&$selected': {
            backgroundColor: 'lightblue !important'
        }
    },
    ListIteminactive:
    {
        backgroundColor: 'rgb(230, 230, 230)',
        '&:hover': {
            backgroundColor: 'gray',
        },
        '&$selected': {
            backgroundColor: 'gray !important'
        }
    },
    selected: {
    }
});

interface Props {
    isMenuExpanded: boolean,
    classes?: any,
    isGSLoading: any,
    serialNumber: any,
    generalServiceData: any,
    selectedBulletin: any,
    isGSDetailLoading: any,
    selectGSBulletin: Function,
    Loadingbulletindetails: Function,
    Completedloadingbulletindetails: Function,
    isAuthenticatedOnce: boolean,
    LoadServiceBulletin: Function,
    StopGSLoading: Function,
    ClearViewBulletinData: Function,
    ClearGSList: Function,
    UpdateBulletins: Function,
    LoadGSNumber: Function,
    UpdateGSInfo: Function,
    UpdateSearchInfo: Function,
    searchInfo: any,
    LoadGeneralServiceInformation: Function
    filterGSInfo: Function,
    AllGSData: any,
    ClearGSStore: Function
}
interface State {
    currentUrl: any,
    selectedfilterValue: any
}
class GeneralServiceInformation extends React.Component<Props, State> {
    state = { currentUrl: '', selectedfilterValue: 'All' };
    filter = [{ id: 1, name: 'All' }, { id: 2, name: 'Bulletins' }, { id: 3, name: 'Documents' }];


    LoadServiceBulletin = (data: any) => {
        this.props.LoadServiceBulletin(data);
    };
    LoadGSNumber = (data: any) => {
        this.props.LoadGSNumber(data);
        this.setState({
            selectedfilterValue: 'All'
        });
    };
    UpdateSerialNumber = (_data: any) => {
    };
    UpdateSearchInfo = (data: any) => {
        this.props.UpdateSearchInfo(data);
    };
    StopLoading = () => {
        this.props.StopGSLoading();
    };
    ClearAll = () => {
        this.props.ClearGSList();
    };


    handleGSInfoSearch = async (serviceBulletins: any) => {
        await this.props.UpdateGSInfo(serviceBulletins);
    };
    handlefilter = (item: any) => {
        const value = this.filter.find((x: any) => {
            return x.id === item;
        });
        if (value !== undefined) {
            this.setState({
                selectedfilterValue: value.name
            });

            const copyArray = JSON.parse(JSON.stringify(this.props.AllGSData));
            if (value.id === 1) {
                var newArray = this.props.AllGSData;
            }
            if (value.id === 2) {
                var newArray = copyArray.filter(function (el: any) {
                    return el.documentType === 1;
                });
            }
            if (value.id === 3) {
                var newArray = copyArray.filter(function (el: any) {
                    return el.documentType === 0;

                });
            }
            this.props.filterGSInfo(value.id, newArray);
        }


        console.log(this.state.selectedfilterValue);


    };
    async componentDidMount() {
        this.props.ClearGSStore();
        this.props.LoadGeneralServiceInformation('All');
    }

    renderLeft = (data: any, classes: any, id: any) => {
        if (data.active === false && !isRoleExists(4)) {
            return null;
        } else {
            return (
                <Paper className="manualPaper" elevation={0} key={data[id]}
                    style={{ backgroundColor: data.serviceBulletinStatusId === 0 || data.serviceBulletinStatusId === 4 ? '' : 'rgba(0, 0, 0, 0.08)' }}>
                    <ListItemAny button key={data[id]} onClick={this.selectBulletinItemClick(data, id)}
                        selected={this.props.selectedBulletin && data[id] === this.props.selectedBulletin[id]}
                        className={(data.active) ? classes.ListItemactive : classes.ListIteminactive}>
                        <ListItemText>
                            <div>
                                <GridAny container justifyContent="space-between" className="font14">
                                    <div className={data.active ? 'headerLeft trimText' : 'gsheaderLeft trimText'}>
                                        {data.documentType === 0 ? data.displayName : data.gsPartNumber}
                                    </div>
                                    <div className={data.active ? ' font10 modelName' : 'gsfont10 modelName'}>
                                        {new Date(data.startDate + 'Z').toLocaleDateString(undefined, { month: 'short', year: 'numeric' })}
                                    </div>
                                    <span className={data.active ? classes.bulletinleftPanelistItem : classes.gsbulletinleftPanelistItem}>{data.description}</span>
                                </GridAny>
                            </div>
                        </ListItemText>
                    </ListItemAny>
                </Paper>
            );
        }
    };

    render() {
        const { classes, isGSLoading, isGSDetailLoading, generalServiceData } = this.props;
        const isMenuExpanded = this.props.isMenuExpanded;
        return (
            <GridAny className="viewBulletinGrid">
                <GridAny container justifyContent="space-between">
                    <GSInfoSearch handleGSInfoSearch={this.handleGSInfoSearch} LoadGSNumber={this.LoadGSNumber}
                        UpdateSearchInfo={this.UpdateSearchInfo} StopLoading={this.StopLoading}
                        isLoading={this.props.isGSLoading} searchInfo={this.props.searchInfo} ClearAll={this.ClearAll} />
                    <div>
                        <GridAny container justifyContent="space-between">
                            <div className={classes.GsInfoMargin}>
                                {isRoleExists(4) && <UploadBulletin title="Upload bulletins" />}
                            </div>
                            <div>
                                {isRoleExists(4) && <UploadGSInfoView title="Upload documents" />}
                            </div>
                        </GridAny>
                    </div>
                </GridAny>
                <div className="divheight" />
                <GridAny>
                    <MenuList listItems={this.filter} onClick={this.handlefilter} selectTitle={'Type'}
                        displaySelectedItemInTitle={true} selectedItem={this.state.selectedfilterValue} />
                </GridAny>
                <GridAny container justifyContent="space-between" className="viewManualListPDF">
                    <GridAny className={isMenuExpanded ? 'viewManualLeftExpanded' : 'viewManualLeft'}>
                        {
                            isGSLoading ?
                                <div className="leftInitial">
                                    <CircularProgress color="secondary" />
                                </div> :
                                (generalServiceData && generalServiceData.length ?
                                    <div>
                                        <div className="resultsHeader font14 boldFont">Results  </div>
                                        <List component="nav" className={classes.rootList}>
                                            {generalServiceData.map((x: any) => {
                                                return this.renderLeft(x, classes, 'gsId');
                                            })
                                            }
                                        </List>
                                    </div> :
                                    <div className="leftInitial">No Data for the selected filter</div>)
                        }
                    </GridAny>
                    <div className="divider"></div>
                    <GridAny item xs={7} className={isMenuExpanded ? 'rightExpandedgs' : 'rightgs'}>
                        {isGSDetailLoading ?
                            <div className="rightInitial">
                                <CircularProgress color="secondary" />
                            </div>
                            :
                            <div>
                                {this.props.selectedBulletin !== undefined ?
                                    <div>
                                        <GridAny container justifyContent="space-between" className="serviceManualDetailWidth">
                                            <GridAny container justifyContent="center">
                                                <div className="inActiveBulletin">
                                                    {((this.props.selectedBulletin.serviceBulletinStatusId !== 0 && this.props.selectedBulletin.serviceBulletinStatusId !== 4) &&
                                                        'INACTIVE (Content moved to Service Manual or not valid any longer)') ||
                                                        (!this.props.selectedBulletin.active && 'INACTIVE (Content not valid any longer)')}
                                                </div>
                                            </GridAny>
                                            <GridAny item xs={4}>
                                                <GridAny container>
                                                    {isRoleExists(4) && this.props.selectedBulletin.documentType === 0 &&
                                                        <GridAny item xs={1}>
                                                            <div>  <EditGSInfo /></div>
                                                        </GridAny>
                                                    }
                                                    <GridAny item xs={11}>
                                                        {
                                                            this.props.selectedBulletin.displayName ?
                                                                <div className="serviceBulletinRightContents font14"> {this.props.selectedBulletin.displayName}</div> :
                                                                <div className="serviceBulletinDescriptionContents font14">
                                                                    {(this.props.selectedBulletin.description === null ||
                                                                        this.props.selectedBulletin.description === undefined) ? ''
                                                                        : this.props.selectedBulletin.description}
                                                                </div>
                                                        }
                                                    </GridAny>
                                                </GridAny>
                                            </GridAny>
                                            <GridAny item xs={4}>
                                                <div className="serviceBulletinRightContents font14"> {
                                                    (this.props.selectedBulletin.gsPartNumber == null || this.props.selectedBulletin.gsPartNumber === undefined) ?
                                                        '' : this.props.selectedBulletin.gsPartNumber}</div>
                                            </GridAny>
                                            <div>
                                                <div className="serviceBulletinRightContents font14">{
                                                    ((this.props.selectedBulletin.revision == null || this.props.selectedBulletin.revision === undefined) ?
                                                        '' : 'Rev ' + this.props.selectedBulletin.revision + ', ') + new Date(this.props.selectedBulletin.startDate + "Z").toLocaleDateString(undefined, { month: 'short', year: 'numeric' })}</div>
                                            </div>
                                        </GridAny>
                                        {
                                            this.props.selectedBulletin.displayName &&
                                            <div className="serviceBulletinDescriptionContents font14">{
                                                (this.props.selectedBulletin.description === null || this.props.selectedBulletin.description === undefined) ?
                                                    '' : this.props.selectedBulletin.description}
                                            </div>
                                        }
                                        <GridAny className="pdfContainer pdfContainerWithData">
                                            {this.props.selectedBulletin !== undefined &&
                                                this.props.isAuthenticatedOnce &&
                                                <object data={this.props.selectedBulletin.url} type="application/pdf" className="viewManualPDf" >
                                                    <embed src={this.props.selectedBulletin.url} type="application/pdf" />
                                                </object>}
                                        </GridAny>
                                    </div>
                                    :
                                    <div className="pdfContainer">
                                        <p>Select a document from the list</p>
                                    </div>
                                }
                            </div>
                        }
                    </GridAny>
                </GridAny>
            </GridAny>)
    }

    selectBulletinItemClick = (data: any, id: any) => async (event: any) => {
        this.setState(() => {
            this.props.selectGSBulletin(data);
        });
    };
}
const mapStateToProps = (state: any) => ({
    state: state.viewGeneralServiceInformation,
    isGSLoading: state.viewGeneralServiceInformation.isGSLoading,
    generalServiceData: state.viewGeneralServiceInformation.generalServiceData,
    selectedBulletin: state.viewGeneralServiceInformation.selectedBulletin,
    isGSDetailLoading: state.viewGeneralServiceInformation.isGSDetailLoading,
    selectGSBulletin: state.viewGeneralServiceInformation.selectGSBulletin,
    isAuthenticatedOnce: state.viewGeneralServiceInformation.isAuthenticatedOnce,
    searchInfo: state.viewGeneralServiceInformation.searchInfo,
    AllGSData: state.viewGeneralServiceInformation.AllGSData

});

const mapDispatchtoProps = (dispatch: any) =>
    bindActionCreators(actionCreators, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchtoProps
)(withStyles(styles as any)(GeneralServiceInformation) as any);
